import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'ago',
    standalone: false
})
export class AgoPipe implements PipeTransform {
  transform(value: any): any {
    return moment(value).fromNow();
  }
}
